import { __decorate, __extends } from "tslib";
import { CustomElement, attachShadowTemplate, upgradeProperty } from '@tyler-components-web/core';
import { ChipSetAdapter } from './chip-set-adapter';
import { ChipSetFoundation } from './chip-set-foundation';
import { CHIP_SET_CONSTANTS } from './chip-set-constants';
import { ChipComponent } from '../chip/chip';
var template = require('./chip-set.html');
var styles = require('./chip-set.css');
var ChipSetComponent = /** @class */ (function (_super) {
    __extends(ChipSetComponent, _super);
    function ChipSetComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, CHIP_SET_CONSTANTS.elementName, template, styles);
        _this._foundation = new ChipSetFoundation(new ChipSetAdapter(_this));
        return _this;
    }
    Object.defineProperty(ChipSetComponent, "observedAttributes", {
        get: function () {
            return [
                CHIP_SET_CONSTANTS.attributes.VERTICAL,
                CHIP_SET_CONSTANTS.attributes.TYPE,
                CHIP_SET_CONSTANTS.attributes.DENSE,
                CHIP_SET_CONSTANTS.attributes.DISABLED
            ];
        },
        enumerable: true,
        configurable: true
    });
    ChipSetComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'vertical');
        upgradeProperty(this, 'type');
        upgradeProperty(this, 'dense');
        upgradeProperty(this, 'disabled');
    };
    ChipSetComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    ChipSetComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case CHIP_SET_CONSTANTS.attributes.VERTICAL:
                this.vertical = this.hasAttribute(CHIP_SET_CONSTANTS.attributes.VERTICAL);
                break;
            case CHIP_SET_CONSTANTS.attributes.TYPE:
                this.type = newValue;
                break;
            case CHIP_SET_CONSTANTS.attributes.DENSE:
                this.dense = this.hasAttribute(CHIP_SET_CONSTANTS.attributes.DENSE);
                break;
            case CHIP_SET_CONSTANTS.attributes.DISABLED:
                this.disabled = this.hasAttribute(CHIP_SET_CONSTANTS.attributes.DISABLED);
                break;
        }
    };
    Object.defineProperty(ChipSetComponent.prototype, "vertical", {
        get: function () {
            return this._foundation.vertical;
        },
        set: function (value) {
            this._foundation.vertical = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipSetComponent.prototype, "type", {
        get: function () {
            return this._foundation.type;
        },
        set: function (value) {
            this._foundation.type = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipSetComponent.prototype, "dense", {
        get: function () {
            return this._foundation.dense;
        },
        set: function (value) {
            this._foundation.dense = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChipSetComponent.prototype, "disabled", {
        get: function () {
            return this._foundation.disabled;
        },
        set: function (value) {
            this._foundation.disabled = value;
        },
        enumerable: true,
        configurable: true
    });
    ChipSetComponent = __decorate([
        CustomElement({
            name: CHIP_SET_CONSTANTS.elementName,
            dependencies: [ChipComponent]
        })
    ], ChipSetComponent);
    return ChipSetComponent;
}(HTMLElement));
export { ChipSetComponent };
